<main class="relative flex flex-col pt-14 lg:pt-18">
  <!-- 배경 이미지 -->
  <div class="relative w-full">
    <img src="/event/top-bg-mo.svg" alt="top background" class="w-full flex lg:hidden" />
    <img src="/event/top-bg-pc.svg" alt="top background" class="w-full hidden lg:flex" />
    <div class="absolute inset-0 flex flex-col items-center justify-center text-center px-4 gap-4">
      <p class="sb-aggro text-white/40 font-light text-xs">홈 > 방송 홍보 상품 안내</p>
      <h1 class="text-white text-2xl lg:text-4xl">방송 홍보 상품 안내</h1>
      <p class="text-zinc-400 font-medium">
        박람회 참여 기업을 위한<br class="md:hidden" />
        맞춤형 방송 홍보 솔루션을 제공합니다.<br />
        (전국 방송 송출)
      </p>
    </div>
  </div>

  <div class="w-full">
    <!-- 첫 번째 섹션: 참가신청 절차 및 신청서 접수 -->
    <section class="flex flex-col w-full max-w-6xl mx-auto py-8 lg:py-15 gap-8 lg:gap-15 px-4 lg:px-0">
      <!-- 타이틀 -->
      <div class="text-center flex flex-col gap-4">
        <p class="sb-aggro text-zinc-500 text-sm lg:text-base">Partnership Inquiry Guide</p>
        <h1 class="text-2xl lg:text-4xl text-zinc-800">제휴 문의 안내</h1>
      </div>

      <div class="flex flex-col gap-6">
        <!-- PC: 가로 배치, 모바일: 세로 배치 -->
        <div class="flex flex-col lg:flex-row gap-6 lg:gap-10">
          <div class="flex flex-col gap-3 justify-center lg:min-w-75">
            <h1 class="text-zinc-800 text-xl lg:text-3xl">
              제휴 신청 절차 및 <br class="hidden lg:flex" />신청서 접수
            </h1>
            <p class="text-zinc-400 font-medium text-sm lg:text-base">
              제휴신청서(소정 양식) 작성 및
              <br class="hidden lg:flex" />사업자등록증 사본 접수
            </p>
          </div>

          <!-- PC: 가로 배치, 모바일: 세로 배치 -->
          <div class="flex flex-col lg:flex-row gap-4 lg:gap-6 w-full">
            <div class="flex-1 flex flex-col lg:flex-col bg-zinc-50 rounded-2xl pt-10 pb-8 px-8">
              <div class="flex items-end lg:items-start justify-between lg:flex-col lg:gap-6">
                <div class="flex flex-col gap-2.5">
                  <p class="sb-aggro text-zinc-800 font-light">FAX</p>
                  <p class="sb-aggro text-lg text-zinc-800">062-371-3512</p>
                </div>
                <img src="/event/fax.svg" alt="fax icon" class="w-11 h-10 lg:ml-auto" />
              </div>
            </div>

            <div class="flex-1 flex flex-col lg:flex-col bg-zinc-50 rounded-2xl pt-10 pb-8 px-8">
              <div class="flex items-end lg:items-start justify-between lg:flex-col lg:gap-6">
                <div class="flex flex-col gap-2.5">
                  <p class="sb-aggro text-zinc-800 font-light">E-mail</p>
                  <p class="sb-aggro text-lg text-zinc-800">{{ email()?.value || 'Expobuy@naver.com' }}</p>
                </div>
                <img src="/event/email.svg" alt="email icon" class="w-11 h-10 lg:ml-auto" />
              </div>
            </div>
          </div>
        </div>

        <!-- 제휴 신청 절차 -->
        <div class="bg-zinc-50 p-6 lg:p-15 flex flex-col gap-4 lg:gap-6 items-center rounded-2xl">
          <h1 class="text-zinc-800 font-light">제휴 신청 절차</h1>

          <!-- 모바일: 스텝별 카드, PC: 이미지 -->
          <div class="hidden lg:block w-full">
            <img src="/inquiry/progress.svg" alt="제휴 신청 절차" class="w-full" />
          </div>

          <!-- 모바일 버전 스텝 -->
          <div class="flex lg:hidden flex-col w-full">
            <div class="bg-white py-2 px-5 rounded-full flex items-center gap-3">
              <img src="/event/step-1.svg" alt="step icon" class="size-5" />
              <div class="flex-1">
                <p class="text-zinc-800 sb-aggro text-sm font-light">참가신청서 작성</p>
              </div>
              <span class="sb-aggro font-light text-zinc-400 text-xs">STEP 1</span>
            </div>

            <app-icon name="material-symbols:keyboard-arrow-down-rounded" class="text-zinc-200 size-6! mx-auto" />

            <div class="bg-white py-2 px-5 rounded-full flex items-center gap-3">
              <img src="/event/step-2.svg" alt="step icon" class="size-5" />
              <div class="flex-1">
                <p class="text-zinc-800 sb-aggro text-sm font-light">희망 홍보 방식 선택</p>
              </div>
              <span class="sb-aggro font-light text-zinc-400 text-xs">STEP 2</span>
            </div>

            <app-icon name="material-symbols:keyboard-arrow-down-rounded" class="text-zinc-200 size-6! mx-auto" />

            <div class="bg-white py-2 px-5 rounded-full flex items-center gap-3">
              <img src="/event/step-3.svg" alt="step icon" class="size-5" />
              <div class="flex-1">
                <p class="text-zinc-800 sb-aggro text-sm font-light">서류 및 자료 업로드</p>
              </div>
              <span class="sb-aggro font-light text-zinc-400 text-xs">STEP 3</span>
            </div>

            <app-icon name="material-symbols:keyboard-arrow-down-rounded" class="text-zinc-200 size-6! mx-auto" />

            <div class="bg-white py-2 px-5 rounded-full flex items-center gap-3">
              <img src="/event/step-4.svg" alt="step icon" class="size-5" />
              <div class="flex-1">
                <p class="text-zinc-800 sb-aggro text-sm font-light">플랫폼 운영팀 심사</p>
              </div>
              <span class="sb-aggro font-light text-zinc-400 text-xs">STEP 4</span>
            </div>

            <app-icon name="material-symbols:keyboard-arrow-down-rounded" class="text-zinc-200 size-6! mx-auto" />

            <div class="bg-white py-2 px-5 rounded-full flex items-center gap-3">
              <img src="/event/step-5.svg" alt="step icon" class="size-5" />
              <div class="flex-1">
                <p class="text-zinc-800 sb-aggro text-sm font-light">제휴 조건 안내 및 협의</p>
              </div>
              <span class="sb-aggro font-light text-zinc-400 text-xs">STEP 5</span>
            </div>

            <app-icon name="material-symbols:keyboard-arrow-down-rounded" class="text-zinc-200 size-6! mx-auto" />

            <div class="bg-white py-2 px-5 rounded-full flex items-center gap-3">
              <img src="/event/step-6.svg" alt="step icon" class="size-5" />
              <div class="flex-1">
                <p class="text-zinc-800 sb-aggro text-sm font-light">최종 승인 및 참여 확정</p>
              </div>
              <span class="sb-aggro font-light text-zinc-400 text-xs">STEP 6</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-zinc-50 flex flex-col lg:flex-row">
        <img [src]="mediaCard.imageUrl" [alt]="mediaCard.title" class="flex-1 w-full lg:h-82.5 object-fill" />
        <div class="flex-1 flex flex-col gap-6 lg:justify-between px-4 py-6 lg:pb-6 lg:pt-10 lg:px-6">
          <div class="flex flex-col gap-1">
            <h1 class="text-lg lg:text-2xl text-zinc-800">{{ mediaCard.title }}</h1>
            <p class="text-xs lg:text-base text-zinc-500 font-medium">
              {{ mediaCard.subtitle }}
            </p>
          </div>

          <div class="flex flex-col gap-4">
            <ul class="flex flex-col gap-2 text-sm font-medium text-zinc-800">
              @for (point of mediaCard.mainPoints; track $index) {
              <li class="flex items-center">
                <span class="mr-2">•</span>
                <span>{{ point }}</span>
              </li>
              }
            </ul>

            <div class="w-full h-px bg-zinc-200"></div>

            @if (mediaCard.additionalInfo && mediaCard.additionalInfo.length > 0) {
            <div class="text-xs font-medium text-zinc-500 space-y-1">
              @for (info of mediaCard.additionalInfo; track $index) {
              <p [innerHTML]="info"></p>
              }
            </div>
            }
          </div>
        </div>
      </div>

      <div
        routerLink="/inquiry/form"
        class="w-full bg-gradient-banner p-6 lg:px-15 rounded-xl flex flex-col gap-4 lg:flex-row lg:justify-between lg:items-center cursor-pointer">
        <div class="flex flex-col gap-1 text-start">
          <p class="sb-aggro text-lg lg:text-2xl text-white">
            지금 바로 밀리언쇼의<br />맞춤형 방송 홍보 제안을 받아보세요!
          </p>
          <p class="font-medium text-white/80 text-sm lg:text-base">
            브랜드 가치와 노출 효과를<br class="flex lg:hidden" />
            극대화할 수 있는 기회를 놓치지 마세요.
          </p>
        </div>
        <button
          typ="button"
          class="cursor-pointer text-primary-500 text-sm bg-white p-3 rounded-xl sb-aggro h-fit w-fit">
          지금 접수하기
        </button>
      </div>
    </section>

    <!-- 두 번째 섹션: 방송 홍보 상품 안내 -->
    <section class="flex flex-col w-full bg-zinc-50 py-8 lg:py-15 gap-8 lg:gap-15 px-4 lg:px-0">
      <div class="w-full max-w-6xl mx-auto">
        <div class="flex flex-col lg:flex-row gap-6 lg:gap-10 lg:max-h-180">
          <!-- 왼쪽: 고정 영역 (데스크톱에서만 sticky) -->
          <div class="flex flex-col gap-3 justify-start lg:min-w-75 lg:sticky lg:top-20 lg:self-start">
            <h1 class="text-zinc-800 text-xl lg:text-3xl">방송 홍보 상품 안내</h1>
            <p class="text-zinc-400 font-medium text-sm lg:text-base">
              박람회 참여 기업을 위한
              <br class="hidden lg:flex" />
              맞춤형 방송 홍보 솔루션을 제공합니다.
            </p>
          </div>

          <!-- 오른쪽: 스크롤 영역 (데스크톱에서만) -->
          <div class="flex flex-col w-full gap-8 lg:gap-15 lg:pr-4">
            <!-- 상품 안내 -->
            <div class="flex flex-col gap-4">
              <h1 class="text-lg lg:text-xl text-zinc-800">상품 안내</h1>
              <div class="flex flex-col gap-5 bg-zinc-100 rounded-2xl p-4 lg:p-8">
                <!-- 일반 부스 -->
                <div class="flex flex-col lg:flex-row gap-4 lg:gap-0">
                  <div class="flex flex-1 gap-4 lg:gap-6">
                    <img src="/event/normal-booth.svg" alt="일반 부스" class="size-12 lg:size-15" />
                    <div class="flex flex-col gap-2 lg:gap-3">
                      <p class="sb-aggro text-base lg:text-lg text-zinc-800">기본 노출 중심</p>
                      <p class="sb-aggro text-xs lg:text-sm font-light text-zinc-400">스튜디오 촬영 (1~3분)</p>
                    </div>
                  </div>
                  <div class="flex flex-1 gap-6 lg:gap-10">
                    <div class="flex flex-1 flex-col gap-2.5">
                      <p class="sb-aggro font-light text-zinc-800 text-sm lg:text-base">상품 상세</p>
                      <p class="sb-aggro text-zinc-800 text-sm lg:text-base">
                        SBS좋은아침 스튜디오<br />
                        촬영
                      </p>
                    </div>
                    <div class="flex flex-1 flex-col gap-2.5">
                      <p class="sb-aggro font-light text-zinc-800 text-sm lg:text-base">금액</p>
                      <p class="sb-aggro text-zinc-800 text-sm lg:text-base">5,000,000원</p>
                    </div>
                  </div>
                </div>

                <div class="w-full h-px bg-zinc-200"></div>

                <!-- 코너 부스 -->
                <div class="flex flex-col lg:flex-row gap-4 lg:gap-0">
                  <div class="flex flex-1 gap-4 lg:gap-6">
                    <img src="/event/corner-booth.svg" alt="코너 부스" class="size-12 lg:size-15" />
                    <div class="flex flex-col gap-2 lg:gap-3">
                      <p class="sb-aggro text-base lg:text-lg text-zinc-800">인터뷰 + 제품 촬영</p>
                      <p class="sb-aggro text-xs lg:text-sm font-light text-zinc-400">ENG촬영 (3~7분)</p>
                    </div>
                  </div>
                  <div class="flex flex-1 gap-6 lg:gap-10">
                    <div class="flex flex-1 flex-col gap-2.5">
                      <p class="sb-aggro font-light text-zinc-800 text-sm lg:text-base">상품 상세</p>
                      <p class="sb-aggro text-zinc-800 text-sm lg:text-base">전문 촬영팀 구성</p>
                    </div>
                    <div class="flex flex-1 flex-col gap-2.5">
                      <p class="sb-aggro font-light text-zinc-800 text-sm lg:text-base">금액</p>
                      <p class="sb-aggro text-zinc-800 text-sm lg:text-base">25,000,000원</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 납부 방법 -->
            <div class="flex flex-col gap-4">
              <h1 class="text-lg lg:text-xl text-zinc-800">납부 방법</h1>
              <div class="flex flex-col gap-5 bg-zinc-100 rounded-2xl p-4 lg:p-8">
                <div class="flex flex-col gap-2.5">
                  <p class="text-zinc-800 sb-aggro font-light text-sm lg:text-base">계약금</p>
                  <div class="flex flex-col lg:flex-row lg:justify-between lg:items-baseline gap-1 lg:gap-0">
                    <p class="text-zinc-800 sb-aggro text-base lg:text-lg">홍보비 총액</p>
                    <p class="text-zinc-500 sb-aggro font-light text-xs lg:text-base">
                      최종 승인 후 3일 이내 입금 필요
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 온라인 납부 계좌 -->
            <div class="flex flex-col gap-4">
              <h1 class="text-lg lg:text-xl text-zinc-800">온라인 납부 계좌</h1>
              <div class="flex flex-col lg:flex-row gap-4 lg:gap-10 bg-zinc-100 rounded-2xl p-6 lg:p-8 items-center">
                <div class="w-full lg:w-30 mr-auto flex items-center">
                  <p class="sb-aggro text-zinc-800 text-lg lg:text-xl font-light leading-tight break-keep">
                    {{ paymentAccount().bankName }}
                  </p>
                </div>
                <div class="flex flex-col lg:flex-row gap-3 lg:gap-6 lg:mx-auto w-full lg:w-auto">
                  <div class="flex gap-2">
                    <p class="text-zinc-400 font-medium text-sm lg:text-base">계좌번호</p>
                    <p class="text-zinc-800 font-medium text-sm lg:text-base">
                      {{ paymentAccount().accountNumber }}
                    </p>
                  </div>
                  <div class="flex gap-2">
                    <p class="text-zinc-400 font-medium text-sm lg:text-base">예금주</p>
                    <p class="text-zinc-800 font-medium text-sm lg:text-base">
                      {{ paymentAccount().accountHolder }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="mx-auto py-8 lg:py-15 px-4 lg:px-0">
      <app-gallery />
    </section>

    <section class="mx-auto py-8 lg:py-15 px-4 lg:px-0">
      <app-broadcast-schedule-calendar />
    </section>

    <section class="mx-auto py-8 lg:py-15 px-4 lg:px-0 container max-w-7xl">
      <img
        routerLink="/inquiry/form"
        src="/inquiry/inquiry-banner.png"
        alt="inquiry bottom banner"
        class="cursor-pointer w-full hidden lg:flex" />
      <img
        routerLink="/inquiry/form"
        src="/inquiry/inquiry-banner-mo.png"
        alt="inquiry bottom banner"
        class="cursor-pointer w-full lg:hidden" />
    </section>

    <app-sponsor />
  </div>
</main>
